import { render, staticRenderFns } from "./LikertBubbles.vue?vue&type=template&id=6ed9211e&scoped=true&"
import script from "./LikertBubbles.vue?vue&type=script&lang=js&"
export * from "./LikertBubbles.vue?vue&type=script&lang=js&"
import style1 from "./LikertBubbles.vue?vue&type=style&index=1&id=6ed9211e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed9211e",
  null
  
)

export default component.exports